let cachedLanguage: string;
const LanguageDetector = {
    type: 'languageDetector',
    init: (services: any, detectorOptions: any, i18nextOptions: any) => {
    },
    detect: () => {
        // if (1 === 1 && process.env.NODE_ENV === "development") return "es";
        if (cachedLanguage) return cachedLanguage;
        const tags = document.getElementsByName("culture");
        if (tags.length !== 1) return "en";
        return tags[0].getAttribute("content")!;
    },
    cacheUserLanguage: (lng: string) => {
        cachedLanguage = lng;
    }
}
export default LanguageDetector;